import moment from 'moment';
import { format, parse } from '@shared/wrappers/date/date';
import { DAY_MONTH_YEAR } from '@shared/utils/date.utils';
import { SEGMENTATIONS } from '@domain/_screens/overview/segmented/constants';

export function formatDateByFullDateAndFullHour(date) {
    if (date !== undefined) {
        const unformattedDate = new Date(date);
        const fullDate = unformattedDate.toLocaleDateString();
        const hours = unformattedDate.getHours();
        const minutes = unformattedDate.getMinutes();
        return `${fullDate} - ${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
    }
    return undefined;
}

export function formateDateByDayAndMonth(date, reverse = false) {
    if (date !== undefined) {
        const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        const day = new Date(date).getDate();
        const dateMonth = new Date(date).getMonth();
        if (reverse) {
            return `${months.filter((month, index) => index === dateMonth)} ${day}`;
        }
        return `${day} ${months.filter((month, index) => index === dateMonth)}`;
    }
    return undefined;
}

export function getOrdinalMonthDay(number) {
    if ([11, 12, 13].includes(number)) {
        return `${number}th`;
    }

    const ordinal = number % 10;
    const ordinalCases = {
        1: `${number}st`,
        2: `${number}nd`,
        3: `${number}rd`,
    };
    return ordinalCases[ordinal] || `${number}th`;
}

export function formatRequestDate(date): string {
    return date.toISOString().split('T')[0];
}

export function getDaysAgoRequestInterval(numDays, isTodayInclusive = false) {
    const endDate = new Date();
    if (!isTodayInclusive) {
        endDate.setDate(endDate.getDate() - 1);
    }
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - numDays);
    return [formatRequestDate(startDate), formatRequestDate(endDate)];
}
export function getMonthsAgoDateRanges(numberOfMonths, referenceDate) {
    const dateranges = [];

    for (let i = 1; i <= numberOfMonths; i += 1) {
        const previousMonth = referenceDate.getMonth() - i;
        let previousMonthEnd;
        // Special cases: the 31st of any month / February
        if (referenceDate.getDate() === 31
            || (previousMonth === 1 && referenceDate.getDate() > 28)) {
            previousMonthEnd = new Date(referenceDate.getFullYear(),
                previousMonth + 1, 0);
        } else {
            previousMonthEnd = new Date(referenceDate.getFullYear(),
                previousMonth, referenceDate.getDate());
        }

        const previousMonthBegin = new Date(
            previousMonthEnd.getFullYear(),
            previousMonthEnd.getMonth(),
            1,
        );

        dateranges.push(`${formatRequestDate(previousMonthBegin)},${formatRequestDate(previousMonthEnd)}`);
    }
    return dateranges;
}
const DAYS_OF_WEEK = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
];

export const getCurrentDayOfWeek = () => {
    const d = new Date();
    const dayIdx = d.getDay();
    return DAYS_OF_WEEK[dayIdx];
};
const MONTH = 'month';
const YEAR = 'year';

export const setFormatedComparedDate = ({ endDate, startDate, typeOfRange }) => {
    const formattedStartDate = moment(startDate);
    const formattedEndDate = moment(endDate);

    const interval = formattedEndDate.diff(formattedStartDate, 'days');

    let comparedStartDate;
    let comparedEndDate;

    if (typeOfRange === MONTH) {
        comparedStartDate = moment(startDate).subtract(interval + 1, 'days');
        comparedEndDate = moment(startDate).subtract(1, 'days');
    } else if (typeOfRange === YEAR) {
        comparedStartDate = moment(startDate).subtract(1, 'year');
        comparedEndDate = moment(endDate).subtract(1, 'year');
    }
    return {
        startDate: comparedStartDate,
        endDate: comparedEndDate,
    };
};

export const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
oneMonthAgo.setHours(0, 0, 0);
oneMonthAgo.setMilliseconds(0);
export const currentDate = new Date();
export const getMomentFromDate = date => moment.utc(date);
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const toApiDateFormat = date => format(new Date(date), API_DATE_FORMAT);
export const stringToDate = (
    date, dateFormat = DAY_MONTH_YEAR,
) => parse(date, dateFormat, new Date());
export const getDayOfWeek = (date: Date) => date.getUTCDay();

export const DATE_FORMAT_BY_SEGMENTATION = {
    [SEGMENTATIONS.DATE]: 'DD/MM/YY',
    [SEGMENTATIONS.WEEK]: 'DD/MM/YY',
    [SEGMENTATIONS.MONTH]: 'MM/YY',
    [SEGMENTATIONS.QUARTER]: 'MM/YY',
};
